// Destination Category Icons
import CategoryDestinationAccomodation from "../icons/components/CategoryDestinationAccomodation";
import CategoryDestinationCity from "../icons/components/CategoryDestinationCity";
import CategoryDestinationCityPoi from "../icons/components/CategoryDestinationCityPoi";
import CategoryDestinationForest from "../icons/components/CategoryDestinationForest";
import CategoryDestinationGarden from "../icons/components/CategoryDestinationGarden";
import CategoryDestinationInstitution from "../icons/components/CategoryDestinationInstitution";
import CategoryDestinationIsland from "../icons/components/CategoryDestinationIsland";
import CategoryDestinationMonument from "../icons/components/CategoryDestinationMonument";
import CategoryDestinationMountain from "../icons/components/CategoryDestinationMountain";
import CategoryDestinationMuseum from "../icons/components/CategoryDestinationMuseum";
import CategoryDestinationNaturalPark from "../icons/components/CategoryDestinationNaturalPark";
import CategoryDestinationPoi from "../icons/components/CategoryDestinationPoi";
import CategoryDestinationRestaurant from "../icons/components/CategoryDestinationRestaurant";
import CategoryDestinationThemePark from "../icons/components/CategoryDestinationThemePark";
import CategoryDestinationWater from "../icons/components/CategoryDestinationWater";
import CategoryDestinationWine from "../icons/components/CategoryDestinationWine";
// Search Icons
import SearchActivateLocation from "../icons/components/SearchActivateLocation";
import SearchDesactivateLocation from "../icons/components/SearchDesactivateLocation";
// Post type
import PostTypeGeopic from "../icons/components/PostTypeGeopic";

export default {
  // Destination Category Icons
  accomodation: {
    component: CategoryDestinationAccomodation
  },
  city: {
    component: CategoryDestinationCity
  },
  citypoi: {
    component: CategoryDestinationCityPoi
  },
  forest: {
    component: CategoryDestinationForest
  },
  garden: {
    component: CategoryDestinationGarden
  },
  institution: {
    component: CategoryDestinationInstitution
  },
  island: {
    component: CategoryDestinationIsland
  },
  monument: {
    component: CategoryDestinationMonument
  },
  mountain: {
    component: CategoryDestinationMountain
  },
  museum: {
    component: CategoryDestinationMuseum
  },
  naturalpark: {
    component: CategoryDestinationNaturalPark
  },
  poi: {
    component: CategoryDestinationPoi
  },
  restaurant: {
    component: CategoryDestinationRestaurant
  },
  themepark: {
    component: CategoryDestinationThemePark
  },
  water: {
    component: CategoryDestinationWater
  },
  wine: {
    component: CategoryDestinationWine
  },
  // Search Icons
  activateLocation: {
    component: SearchActivateLocation
  },
  desactivateLocation: {
    component: SearchDesactivateLocation
  },
  // Post Type Icon
  geopic: {
    component: PostTypeGeopic
  }
};
